import "core-js/modules/es.array.reduce.js";
import t from "supercluster";
import { Children as e, createElement as r, PureComponent as n } from "react";
import { MapContext as o } from "@urbica/react-map-gl";

function i(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}

function u() {
  return (u = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function s(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

var a = function a(t, e) {
  return void 0 === e && (e = {}), {
    type: "Feature",
    properties: e,
    geometry: {
      type: "Point",
      coordinates: t
    }
  };
},
    p = function p(t) {
  return e.toArray(t).map(function (t) {
    return t.key;
  });
},
    c = function (n) {
  var c, l;

  function m(o) {
    var u;
    return i(s(u = n.call(this, o) || this), "_map", void 0), i(s(u), "_cluster", void 0), i(s(u), "_createCluster", function (r) {
      var n = r.minZoom,
          o = r.maxZoom,
          i = r.radius,
          s = r.extent,
          p = r.nodeSize,
          c = r.children,
          l = r.reduce,
          m = r.map,
          d = new t({
        minZoom: n,
        maxZoom: o,
        radius: i,
        extent: s,
        nodeSize: p,
        reduce: l,
        map: m
      }),
          f = e.map(c, function (t) {
        return a([t.props.longitude, t.props.latitude], t);
      });
      d.load(f), u._cluster = d;
    }), i(s(u), "_recalculate", function () {
      var t = u._map.getZoom(),
          e = u._map.getBounds().toArray(),
          r = e[0].concat(e[1]),
          n = u._cluster.getClusters(r, Math.round(t));

      u.setState(function () {
        return {
          clusters: n
        };
      });
    }), i(s(u), "_renderCluster", function (t) {
      var e = t.geometry.coordinates,
          n = e[0],
          o = e[1],
          i = t.properties,
          s = i.cluster_id,
          a = i.point_count,
          p = i.point_count_abbreviated;
      return r(u.props.component, {
        longitude: n,
        latitude: o,
        clusterId: s,
        pointCount: a,
        pointCountAbbreviated: p,
        key: "cluster-" + t.properties.cluster_id
      });
    }), u.state = {
      clusters: []
    }, u;
  }

  l = n, (c = m).prototype = Object.create(l.prototype), c.prototype.constructor = c, c.__proto__ = l;
  var d = m.prototype;
  return d.componentDidMount = function () {
    this._createCluster(this.props), this._recalculate(), this._map.on("moveend", this._recalculate);
  }, d.componentDidUpdate = function (t) {
    (t.minZoom !== this.props.minZoom || t.maxZoom !== this.props.maxZoom || t.radius !== this.props.radius || t.extent !== this.props.extent || t.nodeSize !== this.props.nodeSize || !function (t, r) {
      if (e.count(t) !== e.count(r)) return !1;
      var n = p(t),
          o = new Set(p(r));
      return n.every(function (t) {
        return o.has(t);
      });
    }(t.children, this.props.children)) && (this._createCluster(this.props), this._recalculate());
  }, d.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.off("moveend", this._recalculate);
  }, d.getCluster = function () {
    return this._cluster;
  }, d.render = function () {
    var t = this;
    return r(o.Consumer, {}, function (e) {
      return e && (t._map = e), 0 === t.state.clusters.length ? null : t.state.clusters.map(function (e) {
        if (e.properties.cluster) return t._renderCluster(e);
        var n = e.properties,
            o = n.type,
            i = n.key,
            s = n.props;
        return r(o, u({
          key: i
        }, s));
      });
    });
  }, m;
}(n);

i(c, "displayName", "Cluster"), i(c, "defaultProps", {
  minZoom: 0,
  maxZoom: 16,
  radius: 40,
  extent: 512,
  nodeSize: 64
});
export default c;